import React from "react";
import { Check } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { MEDIA } from "@/constants/media";
import { Reveal, Overline } from "@/components/Reveal";

const About = () => {
  const { t } = useSite();
  const a = t.about;

  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-12">
        {/* Text */}
        <div className="lg:col-span-5">
          <Reveal>
            <Overline>{a.overline}</Overline>
            <h2 className="mt-6 font-heading text-4xl font-light leading-tight tracking-tight sm:text-5xl">
              {a.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 font-body text-base font-light leading-relaxed text-muted-foreground sm:text-lg">
              {a.text}
            </p>
            <p className="mt-4 font-body text-base font-light leading-relaxed text-muted-foreground">
              {a.text2}
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <ul className="mt-8 space-y-4">
              {[a.point1, a.point2, a.point3].map((p, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center bg-gold text-black">
                    <Check size={12} strokeWidth={3} />
                  </span>
                  <span className="font-body text-sm text-foreground">{p}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>

        {/* Overlapping images */}
        <div className="lg:col-span-7">
          <Reveal delay={0.15} className="relative">
            <div className="relative aspect-[4/5] w-full sm:aspect-[16/11]">
              <img
                src={MEDIA.aboutTailoring}
                alt="Elegant tailoring craftsmanship"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-10 -left-6 hidden aspect-square w-2/5 border-4 border-background sm:block">
              <img
                src={MEDIA.machine2}
                alt="Precision textile machine detail"
                className="h-full w-full object-cover"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
